import React, { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../../context";
import Rotate from "../Rotate";
import Button from "../Button";
import leftArrow from "../../img/left.png";
import rightArrow from "../../img/right.png";
import white_tick from "../../img/white_tick.png";
import crossBtn from "../../img/cross.png";
import PermissionPage from "./PermissionPage";
import {
  totalImagesUploadStatus,
  userLogs,
  patLogs,
  feedBackStatus,
  translateText,
  getImageFeedbackMsg,
  setTotalImageFeedbackMssg,
  isAllImgUploaded,
  imageUpload,
  getKotakRecaptureCase,
  imageFeedback,
  getKotakRecapMenuSection,
  sendRakutenCallback,
  getImgFeedbackFlag,
  getTotalImageFeedbackMssgResume,
  setImageFeedbackResumeStatus,
  setFeedBackStatus,
  setFeedbackCountResume,
  addImageToList,
  getTotalImageFeedbackMssg,
  getCountDownTimer,
  getImageList,
  getstoreCompleteTag,
  setstoreCompleteTag,
} from "../../context/utils";
import car_inspection from "../../img/car_inspection.png";

// import ReactGA from "react-ga4";

let allMandatoryCompleted = true;
let allCompleted = true;
let alignment = false;
let mandatoryMissing = [];
let totalMissing = [];
let logsbugs = true;
let damageModuleExists = false;
let interval;
let totalModuleComplete = "";
let interval2, interval5;

const MenuOpes = () => {
  const {
    nameTag,
    storeCompleteTag,
    storeCompleteImage,
    setStoreCompleteTag,
    setCondition,
    setMandatory,
    currentBlock,
    damageModuleCompleted,
    stepCovered,
    setStepCovered,
    showAlert,
    config,
    setCurrentBlock,
    screen,
    setScreen,
    condition,
    isLandscape,
    setLandscape,
    mandatory,
    completed,
    setCompleted,
    mandatoryCompleted,
    setMandatoryCompleted,
    count1,
    clientId,
    setCount1,
    token,
    setUploaded,
    scrollX,
    setscrollX,
    scrolEnd,
    setscrolEnd,
    setStopPing,
    setCurrentPage,
    inspectionId,
    showFeedBackWarning,
    setShowFeedBackWarning,
    imageFeedbackPopupRef,
    setImageFeedbackPopupRef,
    setFeedbackReceived,
    setFeedBackBtndisabled,
    totalImageForAnalysis,
    disabled,
    setDisabled,
    setPage,
  } = useContext(AppContext);

  const land = () => window.innerWidth > window.innerHeight * 1.2;
  const modalRef = useRef();
  let scrl = useRef();
  const kotakRecapturePopup = useRef();
  const menufeedBackPopUp = useRef();
  const imageFeebackPopup = useRef();
  const confirmEnd2 = useRef();
  const [reduce, setReduce] = useState(false);
  const [tempFlag, setTempFlag] = useState(true);
  const [intervalRef, setIntervalRef] = useState(true);
  const [countDown, setCountDown] = useState(getCountDownTimer());
  const [damageUiUpdate, setDamageUiUpdate] = useState(false);
  const [menuBlocks, setMenuBlocks] = useState(config["blocks"]);
  let isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  let isAndroid = /Android/.test(navigator.userAgent);
  const [showPreviewIamge, setShowPreviewImage] = useState(false);
  window.onresize = () => {
    //patLogs(land() ? "Landscape Mode" : "Portrait Mode", inspectionId);
    //userLogs({ position: 11, screen_orientation: "yes", inspectionId });
    setLandscape(land());
  };

  const getTranslateText = (text) => {
    if (Object.keys(config["language"]).includes(text)) {
      return config["language"][text];
    } else {
      // const data = translateText(text, config["language"]["langCode"]);
      return text;
    }
  };

  // const slide = (shift) => {
  //   scrl.current.scrollLeft += shift;
  //   setscrollX(scrollX + shift);
  //   if (
  //     Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <=
  //     scrl.current.offsetWidth
  //   ) {
  //     setscrolEnd(true);
  //   } else {
  //     setscrolEnd(false);
  //   }
  // };

  const scrollCheck = () => {
    setscrollX(scrl.current.scrollLeft);
    if (
      Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <=
      scrl.current.offsetWidth
    ) {
      setscrolEnd(true);
    } else {
      setscrolEnd(false);
    }
  };

  // const modalSuccess = () => {
  //   patLogs(
  //     `Warning given to user, some module is not completed, still clicked to submit button`,
  //     inspectionId
  //   );
  //   setScreen("success");
  //   checkData();
  // };

  const switchLandscape = () => {
    const element = document.documentElement;
    if (element.requestFullscreen) {
      element
        .requestFullscreen()
        .then(() => {
          if (screen.orientation && screen.orientation.lock) {
            screen.orientation
              .lock("landscape")
              .then(function success() {})
              .catch(function error(e) {
                // console.log(e.message);
              });
          } else if (
            window.screen &&
            window.screen.orientation &&
            window.screen.orientation.lock
          ) {
            window.screen.orientation
              .lock("landscape")
              .then(function success() {})
              .catch(function error(e) {
                // console.log(e.message);
              });
          }
        })
        .catch((error) => {
          // console.log('Failed to enter fullscreen mode:', error);
        });
    }
  };

  useEffect(() => {
    config["blocks"].map((e) => {
      if (Object.values(e).includes("damage")) {
        damageModuleExists = true;
      }
    });
    if (logsbugs) {
      // ReactGA.send({
      //   hitType: "pageview",
      //   page: "Menu Page",
      //   title: "Menu Page",
      // });
      //patLogs(land() ? "Landscape Mode" : "Portrait Mode", inspectionId);
      // userLogs({ position: 8, last_page: "menu page", inspectionId });
      logsbugs = false;
    }
    setStopPing(true);
    allCompleted = true;
    allMandatoryCompleted = true;
    mandatoryMissing = [];
    totalMissing = [];
    setLandscape(land());
    if (config["blocks"].length <= 2) {
      alignment = true;
    }
    Object.keys(mandatory).map((item) => {
      if (mandatory[item] === "pending") {
        mandatoryMissing.push(item);
        allMandatoryCompleted = false;
      }
    });
    Object.keys(condition).map((item) => {
      if (condition[item] === "pending") {
        totalMissing.push(item);
        allCompleted = false;
      }
    });
    setCount1(count1 + 1);
    if (allCompleted) setCompleted(true);
    if (allMandatoryCompleted) setMandatoryCompleted(true);

    config["blocks"].map((e) => {
      if (e["id"].length > 14) {
        setReduce(true);
      }
    });
    totalModuleComplete = "";
    Object.keys(condition).map((e) => {
      if (condition[e] === "completed") {
        totalModuleComplete = e + "," + totalModuleComplete;
      }
    });
    userLogs({
      position: 13,
      completed_module: totalModuleComplete,
      inspectionId,
    });
    if (Object.keys(config).includes("TimeOut")) {
      setTimeout(() => {
        // console.log(config["TimeOut"]["timeInMinutes"] * 1000 * 60);
        if (!["success"].includes(screen)) {
          setScreen("timeOut");
        }
      }, config["TimeOut"]["timeInMinutes"] * 1000 * 60);
    }
  }, [isLandscape, damageUiUpdate]);

  useEffect(() => {
    switchLandscape();
    setPage("damage");
  }, []);

  const selectModule = (item) => {
    if (disabled) {
      return;
    }
    setCurrentBlock(item);
    setScreen("block");
  };

  const removeModal = () => {
    // patLogs(
    //   `user clicked cross button to close warning and move to menu page`,
    //   inspectionId
    // );
    modalRef.current.style.display = "none";
  };

  const sortBlock = (feedback) => {
    let tempCurrentBlock = menuBlocks;
    if (feedback === "Feedback") {
      tempCurrentBlock.sort((a, b) => {
        if (a["tag"] === "360 Image") return -1;
        if (b["tag"] === "360 Image") return 1;
        return 0;
      });
    } else {
      const totalMissingSet = new Set(totalMissing);
      const mandatoryMissingSet = new Set(mandatoryMissing);

      tempCurrentBlock.sort((a, b) => {
        const aMandatoryIncomplete = mandatoryMissingSet.has(a["id"]);
        const bMandatoryIncomplete = mandatoryMissingSet.has(b["id"]);

        const aIncomplete = totalMissingSet.has(a["id"]);
        const bIncomplete = totalMissingSet.has(b["id"]);

        // Sort by mandatory and incomplete status
        if (aMandatoryIncomplete && !bMandatoryIncomplete) return -1;
        if (!aMandatoryIncomplete && bMandatoryIncomplete) return 1;

        if (aMandatoryIncomplete && bMandatoryIncomplete) return 0;

        if (aIncomplete && !bIncomplete) return -1;
        if (!aIncomplete && bIncomplete) return 1;

        return 0;
      });
    }
    setMenuBlocks(tempCurrentBlock);
  };

  const successPage = () => {
    // console.log(
    //   "consition ares :::: ++++ ",
    //   mandatoryCompleted,
    //   completed,
    //   mandatory,
    //   condition
    // );
    patLogs(`Submit button clicked`, inspectionId);
    if (!allMandatoryCompleted || !allCompleted) {
      patLogs(
        `Submit button clicked and warning given to user that some module is not completed`,
        inspectionId
      );
      // patLogs(
      //   `Submit button clicked and warning given to user that some module is not completed -> ${totalMissing.join(
      //     ", "
      //   )}`,
      //   inspectionId
      // );
      if (imageFeedbackPopupRef) {
        imageFeebackPopup.current.style.display = "none";
        setImageFeedbackPopupRef(false);
        clearInterval(interval2);
      }
      modalRef.current.style.display = "flex";
      return;
    }
    // console.log("menu final 1 ::::  ", feedBackStatus());
    if (feedBackStatus() === "checking") {
      menufeedBackPopUp.current.style.display = "flex";
    } else if (feedBackStatus() === "Feedback") {
      menufeedBackPopUp.current.style.display = "none";
      if (process.env.REACT_APP_IMAGE_SLIDER) {
        sortBlock("Feedback");
      }
      setShowFeedBackWarning(true);
      clearInterval(interval);
    } else if (feedBackStatus() === "noFeedback") {
      clearInterval(interval);
       storeCompleteImage.map((e) => {
          const tags = getstoreCompleteTag();
          if (!tags.includes(e.currentTag)) {
            setstoreCompleteTag(e.currentTag);
            addImageToList(e);
          }
        });
      setTimeout(() => {
        setShowPreviewImage(true);
      }, 200);
      // setScreen("success");
    } else {
      clearInterval(interval);
       storeCompleteImage.map((e) => {
          const tags = getstoreCompleteTag();
          if (!tags.includes(e.currentTag)) {
            setstoreCompleteTag(e.currentTag);
            addImageToList(e);
          }
        });
      setTimeout(() => {
        setShowPreviewImage(true);
      }, 200);
      // setScreen("success");
    }
    checkData();
  };

  const checkData = () => {
    interval = setInterval(() => {
      if (feedBackStatus() === "checking") {
        if (menufeedBackPopUp && menufeedBackPopUp.current)
          menufeedBackPopUp.current.style.display = "flex";
      } else if (feedBackStatus() === "Feedback") {
        clearInterval(interval);
        if (menufeedBackPopUp && menufeedBackPopUp.current)
          menufeedBackPopUp.current.style.display = "none";
        setShowFeedBackWarning(true);
      } else if (feedBackStatus() === "noFeedback") {
        clearInterval(interval);
        if (menufeedBackPopUp && menufeedBackPopUp.current)
          menufeedBackPopUp.current.style.display = "none";
         storeCompleteImage.map((e) => {
          const tags = getstoreCompleteTag();
          if (!tags.includes(e.currentTag)) {
            setstoreCompleteTag(e.currentTag);
            addImageToList(e);
          }
        });
        setTimeout(() => {
          setShowPreviewImage(true);
        }, 200);
        // setScreen("success");
      } else {
        clearInterval(interval);
         storeCompleteImage.map((e) => {
          const tags = getstoreCompleteTag();
          if (!tags.includes(e.currentTag)) {
            setstoreCompleteTag(e.currentTag);
            addImageToList(e);
          }
        });
        setTimeout(() => {
          setShowPreviewImage(true);
        }, 200);
        // setScreen("success");
      }
    }, 1000);
  };

  return !isLandscape ? (
    <Rotate />
  ) : showPreviewIamge ? (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        height: "100dvh",
        padding: "0px",
        width: "100dvw",
        flexDirection: "column",
      }}
    >
      <div className="previewImage" style={{ display: "grid" }}>
        {getImageList().map((e) => {
          // console.log(e);
          if (Array.isArray(e)) {
            return (
              <div className="previewDiv">
                {Object.keys(e[0]).includes("tag") && (
                  <p>
                    {Object.keys(nameTag).includes(e[0].tag)
                      ? nameTag[e[0].tag]
                      : e[0].tag}
                  </p>
                )}
                <img src={e[0].imgData} />
              </div>
            );
          } else {
            return (
              <div className="previewDiv">
                {Object.keys(e).includes("tag") && (
                  <p>
                    {Object.keys(nameTag).includes(e.tag)
                      ? nameTag[e.tag]
                      : e.tag}
                  </p>
                )}
                <img src={e.imgData} />
              </div>
            );
          }
        })}
      </div>
      <div className="previewImagebtn" style={{ display: "flex" }}>
        <button
          style={{
            backgroundColor: config["colors"]["btn"],
          }}
          onClick={() => {
            setInterval(() => imageUpload(inspectionId), 2000);
            setScreen("success");
          }}
        >
          {config["menu-page"]["modal-btn-next"]}
        </button>
      </div>
    </div>
  ) : (
    <div
      className="process"
      style={{
        position: "relative",
        height: "100dvh",
        padding: "0px",
      }}
    >
      <div ref={menufeedBackPopUp} className="imageFeedBackPopup">
        <div style={{ zIndex: 5 }}>
          <p>
            {Object.keys(config).includes("imageFeedback") &&
            Object.keys(config["imageFeedback"]).includes("ImageAnalysisMssg2")
              ? config["imageFeedback"]["ImageAnalysisMssg2"]
              : getTranslateText(
                  "Please wait for some time while we analyse the images"
                )}
          </p>
          <img
            style={{ width: "100px", height: "100px" }}
            src={car_inspection}
          />
        </div>
      </div>

      <div ref={modalRef} className="menu-modal-container">
        {!mandatoryCompleted ? (
          <div className="menu-modal">
            <div className="menu-back-btn">
              <i className="fas fa-times fa-lg" onClick={removeModal}></i>
            </div>
            <h4>{config["menu-page"]["mandatory-modal-text"]}</h4>
            <h4>{mandatoryMissing.join(", ")}</h4>
          </div>
        ) : mandatoryCompleted && !completed ? (
          <div className="menu-modal">
            {!damageModuleCompleted &&
            Object.keys(config["menu-page"]).includes(
              "damageConfirmationPopup"
            ) &&
            damageModuleExists ? (
              <>
                <h4>{config["menu-page"]["damageConfirmationPopup"]}</h4>
                <br></br>
                <br></br>
                <div className="damageConfirmationPopup">
                  <Button
                    text={config["menu-page"]["damageConfirmationPopupYesBtn"]}
                    onclick={() => {
                      modalSuccess();
                      modalRef.current.style.display = "none";
                    }}
                  />
                  <Button
                    text={config["menu-page"]["damageConfirmationPopupNoBtn"]}
                    onclick={() => {
                      modalRef.current.style.display = "none";
                      removeModal();
                    }}
                  />
                </div>
              </>
            ) : (
              <>
                <div className="menu-back-btn">
                  <i className="fas fa-times fa-lg" onClick={removeModal}></i>
                </div>
                <h4>{config["menu-page"]["optional-modal-text"]}</h4>
                {feedBackStatus() === "Feedback" && showFeedBackWarning ? (
                  <h4>
                    {totalMissing.join(", ") +
                      ", " +
                      config["blocks"].filter(
                        (e) => e["tag"] === "360 Image"
                      )[0]["id"]}
                  </h4>
                ) : (
                  <h4>{totalMissing.join(", ")}</h4>
                )}
                <div className="modal-btn-container">
                  <Button
                    text={config["menu-page"]["modal-btn-next"]}
                    onclick={() => {
                      modalRef.current.style.display = "none";
                      modalSuccess();
                    }}
                  />
                </div>
              </>
            )}
          </div>
        ) : null}
      </div>

      <h2
        style={{
          fontSize: "18px",
          height: "10dvh",
          width: "100dvw",
          margin: "0px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {config["menu-page"]["title"]}
      </h2>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
          height: "90dvh",
          width: "100dvw",
        }}
      >
        <div
          style={{
            height: "100%",
            width: "auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-evenly",
            flexDirection: "column",
          }}
        >
          <div style={{ height: "auto", width: "100%", marginLeft: "3%" }}>
            <PermissionPage />
          </div>
          <div
            className="zoom-gif damage_size"
            style={{ width: "100%", height: "auto", marginLeft: "3%" }}
          >
            <div className="dmgIns" style={{ height: "auto" }}>
              <div className="inst" style={{ margin: "0px" }}>
                <img src={config["damage-page"]["zoomIn-menu-image"]} />
                <div>
                  <h3 style={{ fontSize: "14px" }}>
                    {config["damage-page"]["zoomIn-menu-title"]}
                  </h3>
                  <p style={{ fontSize: "12px" }}>
                    {config["damage-page"]["zoomIn-menu-text"]}
                  </p>
                </div>
              </div>
              <div className="inst" style={{ margin: "0px" }}>
                <img src={config["damage-page"]["zoomOut-menu-image"]} />
                <div>
                  <h3 style={{ fontSize: "14px" }}>
                    {config["damage-page"]["zoomOut-menu-title"]}
                  </h3>
                  <p style={{ fontSize: "12px" }}>
                    {config["damage-page"]["zoomOut-menu-text"]}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="opesDiv">
            <button
              style={{
                backgroundColor: disabled ? "#CCCCCC" : config["colors"]["btn"],
              }}
              onClick={() => {
                if (disabled) {
                  return;
                }
                modalRef.current.style.display = "none";
                successPage();
              }}
            >
              {config["menu-page"]["modal-btn-next"]}
            </button>
          </div>
        </div>
        <div
          className="process-main"
          style={{
            width: "auto",
            height: "90dvh",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            className="process-steps"
            ref={scrl}
            onScroll={scrollCheck}
            style={
              alignment
                ? {
                    display: "flex",
                    justifyContent: "flex-start",
                    flexDirection: "column",
                    width: "auto",
                    height: "100dvh",
                    gap: "0.5em",
                    width: "100%",
                    alignItems: "center",
                  }
                : {
                    gap: "0.5em",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    width: "auto",
                    overflowY: "scroll",
                    scrollBehavior: "smooth",
                    height: "100dvh",
                    width: "100%",
                    alignItems: "center",
                  }
            }
          >
            {menuBlocks.map((item, index) => {
              if (
                item["tag"] === "360 Image" &&
                feedBackStatus() === "Feedback" &&
                showFeedBackWarning === true
              ) {
                return (
                  <div key={index}>
                    <div className="menu-options" style={{ fontSize: "12px" }}>
                      {item["mandatory"] ? (
                        <h4 style={{ color: "red" }} key={index}>
                          {item["id"]}&#42;
                        </h4>
                      ) : (
                        <h4 style={{ color: "red" }} key={index}>
                          {item["id"]}
                        </h4>
                      )}
                      <div
                        className="process-vin"
                        style={{
                          border: "2px solid red",
                          width: "120px",
                          height: "100px",
                        }}
                        onClick={() => {
                          selectModule(item);
                        }}
                      >
                        <img src={item["link"]} alt="123"></img>
                      </div>
                    </div>
                  </div>
                );
              } else if (condition[item["id"]] === "completed") {
                return (
                  <div key={index}>
                    <div className="menu-options" style={{ fontSize: "12px" }}>
                      {item["mandatory"] ? (
                        <h4
                          style={{
                            color: config["colors"]["complete-block"],
                          }}
                          key={index}
                        >
                          {item["id"]}&#42;
                        </h4>
                      ) : (
                        <h4
                          style={{
                            color: config["colors"]["complete-block"],
                          }}
                          key={index}
                        >
                          {item["id"]}
                        </h4>
                      )}
                      <div
                        className="process-vin"
                        style={{
                          height: "100px",
                          width: "120px",
                          border: `2px solid ${config["colors"]["complete-block"]}`,
                          opacity:
                            imageFeebackPopup.current &&
                            imageFeebackPopup.current.style.display === "flex"
                              ? ".5"
                              : "",
                        }}
                      >
                        <div
                          className="greenCircleTick"
                          style={{
                            backgroundColor: config["colors"]["complete-block"],
                          }}
                        >
                          <img src={white_tick} alt="1232"></img>
                        </div>
                        <img src={item["link"]} alt="123"></img>
                      </div>
                    </div>
                  </div>
                );
              } else {
                return (
                  <div key={index}>
                    <div className="menu-options" style={{ fontSize: "12px" }}>
                      {item["mandatory"] ? (
                        <h4 key={index}>{item["id"]}&#42;</h4>
                      ) : (
                        <h4 key={index}>{item["id"]}</h4>
                      )}
                      <div
                        className="process-vin"
                        style={{
                          height: "100px",
                          width: "120px",
                          border: `1px solid ${config["colors"]["incomplete-block"]}`,
                        }}
                        onClick={() => {
                          selectModule(item);
                        }}
                      >
                        <img src={item["link"]} alt="123"></img>
                      </div>
                    </div>
                  </div>
                );
              }
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuOpes;
